module.exports = __webpack_public_path__ + "img/main_img_2.f1e3b51d.jpg";